import React, { useContext } from 'react';
import { MessageContext } from '../../../context/message-context';
import ReviewStepIllustration from './ReviewStepIllustration';
import PhoneTouchIcon from './img/phone_touch_icon.png';
import PhoneTouchWithPersonIcon from './img/phone_touch_with_person_icon.svg';
export default function GoogleStep() {
    var msg = useContext(MessageContext).msg;
    var googleSteps = [
        {
            text: msg.googleStep.step1,
            step: 1,
        },
        {
            text: msg.googleStep.step2,
            step: 2,
        },
        {
            text: msg.googleStep.step3,
            step: 3,
        },
        {
            text: msg.googleStep.step4,
            step: 4,
        },
        {
            text: msg.googleStep.step5,
            step: 5,
        },
        {
            text: msg.googleStep.step6,
            step: 6,
        },
    ];
    return (React.createElement("div", null,
        React.createElement("div", { className: "step-support", style: { paddingTop: '32px', paddingBottom: '16px' } },
            React.createElement("div", { className: "after-enquete--arrow-bg" }),
            React.createElement("div", { className: "step-support--text", style: { minWidth: 0, overflowWrap: 'anywhere', lineHeight: 1.5 } },
                React.createElement("p", null, msg.googleStep.googleAccountPageNextStep)),
            React.createElement("div", { className: "step-support--icon", style: { flexShrink: 0 } },
                React.createElement("img", { src: PhoneTouchIcon, alt: "" }))),
        React.createElement("p", { style: { fontSize: '12px', lineHeight: 1.6, color: '#5f6368' } }, msg.googleStep.screenNote),
        React.createElement("div", null, googleSteps.map(function (_a) {
            var text = _a.text, step = _a.step;
            return (React.createElement("div", { className: "google-step-info", key: step, style: { paddingBottom: '4px' } },
                React.createElement("h2", { className: "google-step-info__title" },
                    step,
                    ". ",
                    text),
                React.createElement(ReviewStepIllustration, { step: step, title: text })));
        })),
        React.createElement("div", { className: "step-support" },
            React.createElement("div", { className: "step-support--text", style: {
                    width: 'auto',
                    minWidth: 0,
                    overflowWrap: 'anywhere',
                    lineHeight: 1.5,
                } },
                React.createElement("p", { style: { textAlign: 'center' } }, msg.googleStep.goToGooglePageNow)),
            React.createElement("div", { className: "step-support--icon", style: { flexShrink: 0 } },
                React.createElement("img", { src: PhoneTouchWithPersonIcon, alt: "" })))));
}
